import React, { useState } from 'react';

import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://tygqwqcasgjnuhyblqbs.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5Z3F3cWNhc2dqbnVoeWJscWJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5Nzg1NzgsImV4cCI6MjA4NzU1NDU3OH0._EOBBJzwxGboHY1QJ5kAIbp6pVnfNpoxldA4QTJE6cY'
);

// IPIP-120 Items organized by domain and facet
// Each domain has 6 facets, each facet has 4 items
// Format: { text, facet, domain, reversed }
const IPIP_ITEMS = [
  // EXTRAVERSION (E)
  // E1: Friendliness
  { text: "Make friends easily", facet: "E1", domain: "E", reversed: false },
  { text: "Warm up quickly to others", facet: "E1", domain: "E", reversed: false },
  { text: "Feel comfortable around people", facet: "E1", domain: "E", reversed: false },
  { text: "Act comfortably with others", facet: "E1", domain: "E", reversed: false },
  // E2: Gregariousness
  { text: "Love large parties", facet: "E2", domain: "E", reversed: false },
  { text: "Talk to a lot of different people at parties", facet: "E2", domain: "E", reversed: false },
  { text: "Prefer to be alone", facet: "E2", domain: "E", reversed: true },
  { text: "Avoid crowds", facet: "E2", domain: "E", reversed: true },
  // E3: Assertiveness
  { text: "Take charge", facet: "E3", domain: "E", reversed: false },
  { text: "Try to lead others", facet: "E3", domain: "E", reversed: false },
  { text: "Take control of things", facet: "E3", domain: "E", reversed: false },
  { text: "Wait for others to lead the way", facet: "E3", domain: "E", reversed: true },
  // E4: Activity Level
  { text: "Am always busy", facet: "E4", domain: "E", reversed: false },
  { text: "Am always on the go", facet: "E4", domain: "E", reversed: false },
  { text: "Do a lot in my spare time", facet: "E4", domain: "E", reversed: false },
  { text: "Like to take it easy", facet: "E4", domain: "E", reversed: true },
  // E5: Excitement-Seeking
  { text: "Love excitement", facet: "E5", domain: "E", reversed: false },
  { text: "Seek adventure", facet: "E5", domain: "E", reversed: false },
  { text: "Enjoy being reckless", facet: "E5", domain: "E", reversed: false },
  { text: "Would never go hang gliding or bungee jumping", facet: "E5", domain: "E", reversed: true },
  // E6: Cheerfulness
  { text: "Radiate joy", facet: "E6", domain: "E", reversed: false },
  { text: "Have a lot of fun", facet: "E6", domain: "E", reversed: false },
  { text: "Love life", facet: "E6", domain: "E", reversed: false },
  { text: "Am not easily amused", facet: "E6", domain: "E", reversed: true },

  // AGREEABLENESS (A)
  // A1: Trust
  { text: "Trust others", facet: "A1", domain: "A", reversed: false },
  { text: "Believe that others have good intentions", facet: "A1", domain: "A", reversed: false },
  { text: "Trust what people say", facet: "A1", domain: "A", reversed: false },
  { text: "Distrust people", facet: "A1", domain: "A", reversed: true },
  // A2: Morality
  { text: "Would never cheat on my taxes", facet: "A2", domain: "A", reversed: false },
  { text: "Stick to the rules", facet: "A2", domain: "A", reversed: false },
  { text: "Use flattery to get ahead", facet: "A2", domain: "A", reversed: true },
  { text: "Use others for my own ends", facet: "A2", domain: "A", reversed: true },
  // A3: Altruism
  { text: "Make people feel welcome", facet: "A3", domain: "A", reversed: false },
  { text: "Anticipate the needs of others", facet: "A3", domain: "A", reversed: false },
  { text: "Love to help others", facet: "A3", domain: "A", reversed: false },
  { text: "Am indifferent to the feelings of others", facet: "A3", domain: "A", reversed: true },
  // A4: Cooperation
  { text: "Am easy to satisfy", facet: "A4", domain: "A", reversed: false },
  { text: "Can't stand confrontations", facet: "A4", domain: "A", reversed: false },
  { text: "Have a sharp tongue", facet: "A4", domain: "A", reversed: true },
  { text: "Contradict others", facet: "A4", domain: "A", reversed: true },
  // A5: Modesty
  { text: "Dislike being the center of attention", facet: "A5", domain: "A", reversed: false },
  { text: "Believe that I am better than others", facet: "A5", domain: "A", reversed: true },
  { text: "Think highly of myself", facet: "A5", domain: "A", reversed: true },
  { text: "Make myself the center of attention", facet: "A5", domain: "A", reversed: true },
  // A6: Sympathy
  { text: "Sympathize with the homeless", facet: "A6", domain: "A", reversed: false },
  { text: "Feel sympathy for those who are worse off than myself", facet: "A6", domain: "A", reversed: false },
  { text: "Am not interested in other people's problems", facet: "A6", domain: "A", reversed: true },
  { text: "Tend to dislike soft-hearted people", facet: "A6", domain: "A", reversed: true },

  // CONSCIENTIOUSNESS (C)
  // C1: Self-Efficacy
  { text: "Complete tasks successfully", facet: "C1", domain: "C", reversed: false },
  { text: "Excel in what I do", facet: "C1", domain: "C", reversed: false },
  { text: "Handle tasks smoothly", facet: "C1", domain: "C", reversed: false },
  { text: "Misjudge situations", facet: "C1", domain: "C", reversed: true },
  // C2: Orderliness
  { text: "Like order", facet: "C2", domain: "C", reversed: false },
  { text: "Like to tidy up", facet: "C2", domain: "C", reversed: false },
  { text: "Want everything to be 'just right'", facet: "C2", domain: "C", reversed: false },
  { text: "Leave a mess in my room", facet: "C2", domain: "C", reversed: true },
  // C3: Dutifulness
  { text: "Try to follow the rules", facet: "C3", domain: "C", reversed: false },
  { text: "Keep my promises", facet: "C3", domain: "C", reversed: false },
  { text: "Pay my bills on time", facet: "C3", domain: "C", reversed: false },
  { text: "Break rules", facet: "C3", domain: "C", reversed: true },
  // C4: Achievement-Striving
  { text: "Work hard", facet: "C4", domain: "C", reversed: false },
  { text: "Do more than what's expected of me", facet: "C4", domain: "C", reversed: false },
  { text: "Set high standards for myself and others", facet: "C4", domain: "C", reversed: false },
  { text: "Do just enough work to get by", facet: "C4", domain: "C", reversed: true },
  // C5: Self-Discipline
  { text: "Am always prepared", facet: "C5", domain: "C", reversed: false },
  { text: "Carry out my plans", facet: "C5", domain: "C", reversed: false },
  { text: "Finish what I start", facet: "C5", domain: "C", reversed: false },
  { text: "Waste my time", facet: "C5", domain: "C", reversed: true },
  // C6: Cautiousness
  { text: "Avoid mistakes", facet: "C6", domain: "C", reversed: false },
  { text: "Choose my words with care", facet: "C6", domain: "C", reversed: false },
  { text: "Jump into things without thinking", facet: "C6", domain: "C", reversed: true },
  { text: "Make rash decisions", facet: "C6", domain: "C", reversed: true },

  // NEUROTICISM (N)
  // N1: Anxiety
  { text: "Worry about things", facet: "N1", domain: "N", reversed: false },
  { text: "Fear for the worst", facet: "N1", domain: "N", reversed: false },
  { text: "Am afraid of many things", facet: "N1", domain: "N", reversed: false },
  { text: "Am relaxed most of the time", facet: "N1", domain: "N", reversed: true },
  // N2: Anger
  { text: "Get angry easily", facet: "N2", domain: "N", reversed: false },
  { text: "Get irritated easily", facet: "N2", domain: "N", reversed: false },
  { text: "Lose my temper", facet: "N2", domain: "N", reversed: false },
  { text: "Rarely get irritated", facet: "N2", domain: "N", reversed: true },
  // N3: Depression
  { text: "Often feel blue", facet: "N3", domain: "N", reversed: false },
  { text: "Dislike myself", facet: "N3", domain: "N", reversed: false },
  { text: "Am often down in the dumps", facet: "N3", domain: "N", reversed: false },
  { text: "Feel comfortable with myself", facet: "N3", domain: "N", reversed: true },
  // N4: Self-Consciousness
  { text: "Find it difficult to approach others", facet: "N4", domain: "N", reversed: false },
  { text: "Am afraid to draw attention to myself", facet: "N4", domain: "N", reversed: false },
  { text: "Am easily intimidated", facet: "N4", domain: "N", reversed: false },
  { text: "Am not embarrassed easily", facet: "N4", domain: "N", reversed: true },
  // N5: Immoderation
  { text: "Go on binges", facet: "N5", domain: "N", reversed: false },
  { text: "Easily resist temptations", facet: "N5", domain: "N", reversed: true },
  { text: "Am able to control my cravings", facet: "N5", domain: "N", reversed: true },
  { text: "Rarely overindulge", facet: "N5", domain: "N", reversed: true },
  // N6: Vulnerability
  { text: "Panic easily", facet: "N6", domain: "N", reversed: false },
  { text: "Become overwhelmed by events", facet: "N6", domain: "N", reversed: false },
  { text: "Feel that I'm unable to deal with things", facet: "N6", domain: "N", reversed: false },
  { text: "Remain calm under pressure", facet: "N6", domain: "N", reversed: true },

  // OPENNESS (O)
  // O1: Imagination
  { text: "Have a vivid imagination", facet: "O1", domain: "O", reversed: false },
  { text: "Enjoy wild flights of fantasy", facet: "O1", domain: "O", reversed: false },
  { text: "Love to daydream", facet: "O1", domain: "O", reversed: false },
  { text: "Do not have a good imagination", facet: "O1", domain: "O", reversed: true },
  // O2: Artistic Interests
  { text: "Believe in the importance of art", facet: "O2", domain: "O", reversed: false },
  { text: "See beauty in things that others might not notice", facet: "O2", domain: "O", reversed: false },
  { text: "Love to reflect on things", facet: "O2", domain: "O", reversed: false },
  { text: "Do not like art", facet: "O2", domain: "O", reversed: true },
  // O3: Emotionality
  { text: "Experience my emotions intensely", facet: "O3", domain: "O", reversed: false },
  { text: "Feel others' emotions", facet: "O3", domain: "O", reversed: false },
  { text: "Am passionate about causes", facet: "O3", domain: "O", reversed: false },
  { text: "Rarely notice my emotional reactions", facet: "O3", domain: "O", reversed: true },
  // O4: Adventurousness
  { text: "Prefer variety to routine", facet: "O4", domain: "O", reversed: false },
  { text: "Like to visit new places", facet: "O4", domain: "O", reversed: false },
  { text: "Am interested in many things", facet: "O4", domain: "O", reversed: false },
  { text: "Prefer to stick with things that I know", facet: "O4", domain: "O", reversed: true },
  // O5: Intellect
  { text: "Love to read challenging material", facet: "O5", domain: "O", reversed: false },
  { text: "Avoid philosophical discussions", facet: "O5", domain: "O", reversed: true },
  { text: "Have difficulty understanding abstract ideas", facet: "O5", domain: "O", reversed: true },
  { text: "Am not interested in theoretical discussions", facet: "O5", domain: "O", reversed: true },
  // O6: Liberalism
  { text: "Tend to vote for liberal political candidates", facet: "O6", domain: "O", reversed: false },
  { text: "Believe that there is no absolute right and wrong", facet: "O6", domain: "O", reversed: false },
  { text: "Tend to vote for conservative political candidates", facet: "O6", domain: "O", reversed: true },
  { text: "Believe that we should be tough on crime", facet: "O6", domain: "O", reversed: true },
];

const DOMAINS = {
  E: { name: "Extraversion", color: "#f59e0b", description: "Your tendency to seek stimulation in the company of others" },
  A: { name: "Agreeableness", color: "#10b981", description: "Your tendency to be compassionate and cooperative" },
  C: { name: "Conscientiousness", color: "#3b82f6", description: "Your tendency to be organized and dependable" },
  N: { name: "Neuroticism", color: "#8b5cf6", description: "Your tendency to experience negative emotions" },
  O: { name: "Openness", color: "#ec4899", description: "Your tendency to be open to new experiences and ideas" }
};

const ITEMS_PER_PAGE = 10;

function generateParticipantCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = 'BLK-';
  for (let i = 0; i < 4; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export default function IPIPQuiz() {
  const [stage, setStage] = useState('welcome'); // welcome, consent, quiz, results
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [responses, setResponses] = useState({});
  const [shuffledItems, setShuffledItems] = useState([]);
  const [scores, setScores] = useState(null);
  const [participantCode, setParticipantCode] = useState('');
  const [quizStartTime, setQuizStartTime] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [waitlistPreference, setWaitlistPreference] = useState(null); // 'today' or 'future'
  const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);

  const totalPages = Math.ceil(IPIP_ITEMS.length / ITEMS_PER_PAGE);

  const startQuiz = () => {
    setShuffledItems(shuffleArray(IPIP_ITEMS));
    setQuizStartTime(Date.now());
    setStage('quiz');
  };

  const handleResponse = (itemIndex, value) => {
    setResponses(prev => ({ ...prev, [itemIndex]: value }));
  };

  const calculateScores = () => {
    const domainScores = { E: [], A: [], C: [], N: [], O: [] };
    const facetScores = {};

    shuffledItems.forEach((item, index) => {
      const response = responses[index];
      if (response !== undefined) {
        const score = item.reversed ? (6 - response) : response;
        domainScores[item.domain].push(score);
        
        if (!facetScores[item.facet]) facetScores[item.facet] = [];
        facetScores[item.facet].push(score);
      }
    });

    const computed = {};
    Object.keys(domainScores).forEach(domain => {
      const scores = domainScores[domain];
      const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
      const percentile = Math.round(((avg - 1) / 4) * 100);
      computed[domain] = { average: avg.toFixed(2), percentile };
    });

    return { domains: computed, facets: facetScores };
  };

  const submitToZapier = async (data) => {
    try {
      // Create item_order array showing which item was at each position
      const itemOrder = data.shuffledItems.map((item, idx) => ({
        position: idx,
        text: item.text,
        facet: item.facet,
        domain: item.domain,
        reversed: item.reversed
      }));
      
      await fetch('https://hooks.zapier.com/hooks/catch/26157741/uqin53x/', {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          participant_id: data.participantCode,
          name: data.name,
          email: data.email,
          created_at: new Date().toISOString(),
          consent_step1: true,
          E_score: data.scores.domains.E.average,
          A_score: data.scores.domains.A.average,
          C_score: data.scores.domains.C.average,
          N_score: data.scores.domains.N.average,
          O_score: data.scores.domains.O.average,
          facet_scores: JSON.stringify(data.scores.facets),
          raw_responses: JSON.stringify(data.responses),
          item_order: JSON.stringify(itemOrder),
          completion_time_sec: data.completionTime
        })
      });
    } catch (error) {
      console.error('Zapier submission error:', error);
    }
  };

  const submitToSupabase = async (data) => {
    try {
      const { error: participantError } = await supabase
        .from('ipip120_participants')
        .insert({
          name: data.name,
          participant_id: data.participantCode,
          email: data.email,
          consent_step1: true,
          created_at: new Date().toISOString()
        });
  
      if (participantError) console.error('Supabase ipip120_participants error:', participantError);
  
      const { error: responsesError } = await supabase
        .from('ipip_responses')
        .insert({
          participant_id: data.participantCode,
          e_score: data.scores.domains.E.average,
          a_score: data.scores.domains.A.average,
          c_score: data.scores.domains.C.average,
          n_score: data.scores.domains.N.average,
          o_score: data.scores.domains.O.average,
          facet_scores: data.scores.facets,
          raw_responses: data.responses,
          item_order: data.shuffledItems,
          completion_time_sec: data.completionTime,
          created_at: new Date().toISOString()
        });
  
      if (responsesError) console.error('Supabase ipip_responses error:', responsesError);
    } catch (error) {
      console.error('Supabase submission error:', error);
    }
  };
  
  const submitWaitlist = async () => {
    try {
      await fetch('https://hooks.zapier.com/hooks/catch/26157741/uqkt9sa/', {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          participant_id: participantCode,
          name: name,
          email: email,
          phone_number: phoneNumber,
          waitlist_preference: waitlistPreference,
          submitted_at: new Date().toISOString()
        })
      });
      setWaitlistSubmitted(true);
    } catch (error) {
      console.error('Waitlist submission error:', error);
    }
  };

  const handleSubmit = () => {
    const computed = calculateScores();
    const code = generateParticipantCode();
    const endTime = Date.now();
    
    setScores(computed);
    setParticipantCode(code);
    
    // Submit to Zapier
    submitToZapier({
      participantCode: code,
      name: name,
      email: email,
      scores: computed,
      responses: responses,
      shuffledItems: shuffledItems,
      completionTime: Math.round((endTime - quizStartTime) / 1000)
    });

    //Submit to Supabase
    submitToSupabase({
      participantCode: code,
      name: name,
      email: email,
      scores: computed,
      responses: responses,
      shuffledItems: shuffledItems,
      completionTime: Math.round((endTime - quizStartTime) / 1000)
    });
    
    setStage('results');
  };

  const currentItems = shuffledItems.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );

  const allCurrentAnswered = currentItems.every(
    (_, idx) => responses[currentPage * ITEMS_PER_PAGE + idx] !== undefined
  );

  const allAnswered = Object.keys(responses).length === IPIP_ITEMS.length;

  if (stage === 'welcome') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl mx-auto mb-4 flex items-center justify-center">
              <span className="text-2xl font-bold text-white">B</span>
            </div>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">Discover Your Personality Profile</h1>
            <p className="text-slate-600">Blok Research Study</p>
          </div>
          
          <div className="space-y-4 text-slate-600 mb-6">
            <p>Welcome! This questionnaire measures your personality across the Big Five dimensions. It takes about 5 minutes to complete.</p>
            <p>At the end, you'll receive your personalized results and a participant code for the Research Station.</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">First Name & Last Initial</label>
              <input
                type="text"
                id="participant-name"
                name="participant_name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g., Jesse J."
                className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Email Address</label>
              <input
                type="email"
                id="participant-email"
                name="participant_email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
              />
            </div>

            <button
              id="continue-to-consent"
              name="continue_to_consent"
              onClick={() => setStage('consent')}
              disabled={!email.includes('@')}
              className="w-full py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-lg hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (stage === 'consent') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8">
          <h2 className="text-xl font-bold text-slate-800 mb-4">Research Consent</h2>
          
          <div className="bg-slate-50 rounded-lg p-4 mb-6 text-sm text-slate-600 space-y-3 max-h-64 overflow-y-auto">
            <p><strong>Purpose:</strong> This study examines the relationship between personality traits and digital behavior patterns.</p>
            <p><strong>What you'll do:</strong> Complete a 120-item personality questionnaire (approximately 5 minutes).</p>
            <p><strong>Data use:</strong> Your responses will be stored securely and used for research purposes. Your email will only be used to link your data across study components.</p>
            <p><strong>Voluntary participation:</strong> You may withdraw at any time without penalty.</p>
            <p><strong>Contact:</strong> For questions, contact pooja@joinblok.co</p>
          </div>

          <div className="flex gap-3">
            <button
              id="consent-back"
              name="consent_back"
              onClick={() => setStage('welcome')}
              className="flex-1 py-3 border border-slate-300 text-slate-700 font-semibold rounded-lg hover:bg-slate-50 transition-all"
            >
              Back
            </button>
            <button
              id="consent-agree"
              name="consent_agree"
              onClick={startQuiz}
              className="flex-1 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all"
            >
              I Agree, Start Quiz
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (stage === 'quiz') {
    const progress = (Object.keys(responses).length / IPIP_ITEMS.length) * 100;
    
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 p-4">
        <div className="max-w-2xl mx-auto">
          {/* Progress bar */}
          <div className="mb-6">
            <div className="flex justify-between text-sm text-slate-400 mb-2">
              <span>Page {currentPage + 1} of {totalPages}</span>
              <span>{Object.keys(responses).length} of {IPIP_ITEMS.length} answered</span>
            </div>
            <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-amber-500 to-orange-500 transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          {/* Questions */}
          <div className="bg-white rounded-2xl shadow-2xl p-6">
            <p className="text-sm text-slate-500 mb-6">Rate how accurately each statement describes you:</p>
            
            <div className="space-y-4">
              {currentItems.map((item, idx) => {
                const globalIdx = currentPage * ITEMS_PER_PAGE + idx;
                return (
                  <div key={globalIdx} className="border-b border-slate-100 pb-4 last:border-0">
                    <p className="text-slate-800 mb-3 font-medium">{item.text}</p>
                    <div className="flex justify-between gap-2">
                      {[1, 2, 3, 4, 5].map(val => (
                        <button
                          key={val}
                          id={`ipip-item-${globalIdx}-val-${val}`}
                          name={`ipip_item_${globalIdx}`}
                          data-item-id={globalIdx}
                          data-value={val}
                          onClick={() => handleResponse(globalIdx, val)}
                          className={`flex-1 py-2 px-1 text-xs rounded-lg border transition-all ${
                            responses[globalIdx] === val
                              ? 'bg-amber-500 border-amber-500 text-white'
                              : 'border-slate-300 text-slate-600 hover:border-amber-400'
                          }`}
                        >
                          {val === 1 ? 'Very Inaccurate' : val === 2 ? 'Inaccurate' : val === 3 ? 'Neutral' : val === 4 ? 'Accurate' : 'Very Accurate'}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Navigation */}
            <div className="flex gap-3 mt-6">
              <button
                id="quiz-previous"
                name="quiz_previous"
                onClick={() => setCurrentPage(p => p - 1)}
                disabled={currentPage === 0}
                className="flex-1 py-3 border border-slate-300 text-slate-700 font-semibold rounded-lg hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                Previous
              </button>
              {currentPage < totalPages - 1 ? (
                <button
                  id="quiz-next"
                  name="quiz_next"
                  onClick={() => setCurrentPage(p => p + 1)}
                  disabled={!allCurrentAnswered}
                  className="flex-1 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-lg hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  Next
                </button>
              ) : (
                <button
                  id="quiz-submit"
                  name="quiz_submit"
                  onClick={handleSubmit}
                  disabled={!allAnswered}
                  className="flex-1 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold rounded-lg hover:from-green-600 hover:to-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  See Results
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (stage === 'results') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 p-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-slate-800 mb-2">Your Personality Profile</h2>
              <p className="text-slate-500">Based on the Big Five model of personality</p>
            </div>

            {/* Participant Code */}
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-8 text-center">
              <p className="text-sm text-amber-700 mb-1">Your Participant Code</p>
              <p className="text-2xl font-mono font-bold text-amber-600">{participantCode}</p>
              <p className="text-xs text-amber-600 mt-2">Save this code for the research station!</p>
            </div>

            {/* Scores */}
            <div className="space-y-4">
              {Object.entries(DOMAINS).map(([key, domain]) => {
                const score = scores?.domains[key];
                return (
                  <div key={key} className="bg-slate-50 rounded-xl p-4">
                    <div className="flex justify-between items-center mb-2">
                      <div>
                        <h3 className="font-bold text-slate-800">{domain.name}</h3>
                        <p className="text-xs text-slate-500">{domain.description}</p>
                      </div>
                      <div className="text-right">
                        <span className="text-2xl font-bold" style={{ color: domain.color }}>
                          {score?.percentile}%
                        </span>
                      </div>
                    </div>
                    <div className="h-3 bg-slate-200 rounded-full overflow-hidden">
                      <div
                        className="h-full rounded-full transition-all duration-500"
                        style={{ width: `${score?.percentile}%`, backgroundColor: domain.color }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8 p-4 bg-slate-50 rounded-xl text-center">
              <p className="text-slate-600 text-sm">
                Thank you for participating! Visit the Blok Research Station at the event and share your participant code to continue the study.
              </p>
            </div>

            {/* Waitlist Opt-In Section */}
            <div className="mt-6 border-t border-slate-200 pt-6">
              <h3 className="text-lg font-bold text-slate-800 mb-2">Want to go deeper?</h3>
              <p className="text-sm text-slate-600 mb-4">
                We're running a limited number of in-person research sessions during today's summit—about 5-7 slots during networking breaks. Interested? Join the waitlist and we'll text you if a slot opens up.
              </p>

              {!waitlistSubmitted ? (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Phone Number (for text notifications)</label>
                    <input
                      type="tel"
                      id="phone-number"
                      name="phone_number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="(555) 123-4567"
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
                    />
                  </div>

                  <div className="space-y-3">
                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="radio"
                        id="waitlist-today"
                        name="waitlistPreference"
                        checked={waitlistPreference === 'today'}
                        onChange={() => setWaitlistPreference('today')}
                        className="mt-1 w-4 h-4 text-amber-500 border-slate-300 focus:ring-amber-500"
                      />
                      <span className="text-sm text-slate-700">
                        <strong>I'm interested in participating today</strong> — text me if a slot opens up during the summit
                      </span>
                    </label>

                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="radio"
                        id="waitlist-future"
                        name="waitlistPreference"
                        checked={waitlistPreference === 'future'}
                        onChange={() => setWaitlistPreference('future')}
                        className="mt-1 w-4 h-4 text-amber-500 border-slate-300 focus:ring-amber-500"
                      />
                      <span className="text-sm text-slate-700">
                        <strong>Invite me to a future session</strong> — I'd like to participate at a Blok HQ event or schedule a time
                      </span>
                    </label>
                  </div>

                  <button
                    id="join-waitlist"
                    name="join_waitlist"
                    onClick={submitWaitlist}
                    disabled={!phoneNumber || !waitlistPreference}
                    className="w-full py-3 bg-gradient-to-r from-slate-700 to-slate-800 text-white font-semibold rounded-lg hover:from-slate-800 hover:to-slate-900 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    Join Waitlist
                  </button>
                </div>
              ) : (
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-center">
                  <p className="text-green-700 font-medium">You're on the waitlist!</p>
                  <p className="text-green-600 text-sm mt-1">
                    {waitlistPreference === 'today' && "Keep your phone handy—we'll text you if a slot opens up today."}
                    {waitlistPreference === 'future' && "We'll reach out about future sessions at Blok HQ."}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}